



















import { BookBlocks } from './blocks'
import { BookModel, bookModelProvider, getBookModel } from './model'
import { defineClassComponent, useQuery } from '@/hooks'
import { onMounted, ref } from '@vue/composition-api'
import { Track } from '@/utils'

export default defineClassComponent(
  {
    components: BookBlocks,
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '店铺主页',
        }))

        // 提供标销数据
        bookModelProvider.provide(this.bookModel as any)

        onMounted(async () => {
          // 获取标销数据
          this.bookModel.value = (await getBookModel(
            this.query.martId,
          )) as any
          this.loading.value = false
        })
      }

      query = useQuery<{
        martId: string
      }>()

      // 是否加载中
      loading = ref(true)

      // 标销数据
      bookModel = ref<BookModel>({} as any)
    },
)
